export default "__VITE_ASSET__HQ43Kbou__"